module.exports = __webpack_public_path__ + "static/media/vivahub-logo-orange.9fa408ab.svg";